export default "__VITE_ASSET__C7XBbV0q__"